<template>
  <vc-donut
    background="white" 
    foreground="grey"
    :size="190" unit="px" :thickness="8"
    :sections="sections" :total="100"
  >
  <div v-if="this.graphData[0]=='energy'" class="donut-label mb-2">{{$t('energy.energy_saving')}}</div>
  <div class="donut-value">{{(this.percentualeRisparmio.toFixed(1) == "NaN" ? "0.0" : this.percentualeRisparmio.toFixed(1))}}%</div>
  </vc-donut> 
</template>

<script>
import Vue from 'vue';
import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';
Vue.use(Donut);

  export default {
    name: 'GraficoDonutEnergy',
    props: {
      graphData: Array
    },
    mounted(){
        console.log("GRaph data",this.graphData);
        this.energiaRisparmiata=this.graphData[1];
        this.energiaConsumata=this.graphData[2];
        this.percentualeRisparmio=this.energiaRisparmiata/(this.energiaConsumata/1+this.energiaRisparmiata/1)*100;
        console.log("Donut: energia risparmiata ", this.energiaRisparmiata, " energia Consumata", this.energiaConsumata, "perc ", this.percentualeRisparmio );
        this.sections=[];
        var energiaRisparmiata_p={value:this.percentualeRisparmio, color:"#29CC96"};
        var energiaConsumata_p={value:100- this.percentualeRisparmio, color:"orange"};
        this.sections.push(energiaRisparmiata_p);
        this.sections.push(energiaConsumata_p);
    },
    data() {
      return {
          sections: [],
          energiaRisparmiata:0,
          energiaConsumata:0,
          percentualeRisparmio:0
      };
    }
  };
</script>
